import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoIconComponent {
  @Output() clickEvent = new EventEmitter();

  onClick(event: Event): void {
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
